import { ClassroomActionType } from './types';

import { batch } from 'react-redux';
import { getUserClassrooms } from 'api/classroom';
import { setLessonPlannerNavbarAttribute } from 'state/modules/lessonPlanner/thunks';
import { selectClassroom } from 'state/modules/app/actions';
import { requestSuccess, requestInFlight } from 'state/modules/entity';

export const fetchUserClassrooms = () => {
  return async (dispatch, getState) => {
    dispatch(requestInFlight());

    const {
      app: { currentWorkbook, selectedClassroomId }
    } = getState();

    const params = {
      productCurriculumId: currentWorkbook?.products[0].productCurriculumId
    };

    try {
      const { data } = await getUserClassrooms(params);

      batch(async () => {
        if (!selectedClassroomId) {
          const firstClassroomId = data[0]?.id ?? '';
          await dispatch(selectClassroom(firstClassroomId));
          // TODO: Get rid of these in favor of global UI value for selected classroom ID.
          await dispatch(setLessonPlannerNavbarAttribute('classroomId', firstClassroomId));
          await dispatch(setLessonPlannerNavbarAttribute('classroom', data[0]));
        }

        return await dispatch(
          requestSuccess(
            { classrooms: data },
            { requestActionType: ClassroomActionType.CLASSROOMS_REQUEST_SUCCESS }
          )
        );
      });
    } catch (e) {
      dispatch(requestSuccess({}));
    }
  };
};
